// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.ExpandableButtonContainer_expandable-button-container__pr3-Z {
  display: flex;
  flex-direction: column;
}
.ExpandableButtonContainer_expandable-button-container__pr3-Z[data-expanded=true] > button {
  border-radius: 4px 4px 0 0;
}
.ExpandableButtonContainer_expandable-button-container__pr3-Z .ExpandableButtonContainer_title__2iWKa {
  margin: auto;
  padding-left: 21px;
}
.ExpandableButtonContainer_expandable-button-container__pr3-Z .ExpandableButtonContainer_content-wrapper__OAFhP {
  background-color: #555;
  padding: 0.5rem;
  border-radius: 0 0 4px 4px;
}
.ExpandableButtonContainer_expandable-button-container__pr3-Z .ExpandableButtonContainer_content-wrapper__OAFhP button {
  width: 100%;
  height: 36px;
  margin-top: 0.5rem;
  border-radius: 4px;
  font-size: 90%;
  color: #333;
  border-radius: 4;
}
.ExpandableButtonContainer_expandable-button-container__pr3-Z .ExpandableButtonContainer_content-wrapper__OAFhP p {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/containers/ExpandableButtonContainer.module.scss","webpack://./src/utils/_utils.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;AEzBA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AD9BA;EACE,aAAA;EACA,sBAAA;AAqBF;AAlBI;EACE,0BAAA;AAoBN;AAhBE;EACE,YAAA;EACA,kBAAA;AAkBJ;AAfE;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;AAiBJ;AAfI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAEA,cAAA;EACA,WAAA;EAEA,gBAAA;AAeN;AAZI;EACE,YAAA;AAcN","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.expandable-button-container {\n  display: flex;\n  flex-direction: column;\n}\n.expandable-button-container[data-expanded=true] > button {\n  border-radius: 4px 4px 0 0;\n}\n.expandable-button-container .title {\n  margin: auto;\n  padding-left: 21px;\n}\n.expandable-button-container .content-wrapper {\n  background-color: #555;\n  padding: 0.5rem;\n  border-radius: 0 0 4px 4px;\n}\n.expandable-button-container .content-wrapper button {\n  width: 100%;\n  height: 36px;\n  margin-top: 0.5rem;\n  border-radius: 4px;\n  font-size: 90%;\n  color: #333;\n  border-radius: 4;\n}\n.expandable-button-container .content-wrapper p {\n  color: white;\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expandable-button-container": `ExpandableButtonContainer_expandable-button-container__pr3-Z`,
	"title": `ExpandableButtonContainer_title__2iWKa`,
	"content-wrapper": `ExpandableButtonContainer_content-wrapper__OAFhP`
};
export default ___CSS_LOADER_EXPORT___;
